import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../common/Breadcrumbs';
import NewsCard from './NewsCard';
import { axiosInstance } from '../config';
import RecentPost from './RecentPost';
import Loader from '../../common/Loader';
import { Helmet } from 'react-helmet';

const NewsList = () => {
    const [News, setNews] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState(''); // Track search input
    const [data ,setdata] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        getCustomersInfo();
        getData();
    }, []);

    function getCustomersInfo() {
        setLoading(true);
        axiosInstance.get(`news`)
            .then(res => {
                setNews(res?.data?.news);
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false);
            });
    }

    const getData = () => {
        setLoading(true)
        axiosInstance.get(`settings`)
            .then(res => {
                setdata(res?.data?.settings)
            })
            .catch((err) => console.log(err))
            .finally(() => {
                setLoading(false)
            })
    }

    // Filter news based on the search query, or show all if the query is empty
    const filteredNews = searchQuery === ''
        ? News  // If the search query is empty, show all the news
        : News.filter(newsItem =>
            newsItem?.title?.toLowerCase().includes(searchQuery.toLowerCase()) // Filter news based on name
        );

    return (
        <div>
            <Helmet>
                <title>{data[5]?.metatitle || "Precision Contract Cleaning"}</title>
                <meta name="description" content={data[5]?.metadescription || "Precision Contract Cleaning"} />
                <meta name="keywords" content={data[5]?.metakeywords || "Precision Contract Cleaning"} />
            </Helmet>
            {Loading && <Loader />}
            <Breadcrumbs 
                title={data[5]?.title} 
                description={data[5]?.subtitle}
                image={data[5]?.imageUrl} 
            />
            <div className="rs-inner-blog pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="widget-area">
                            <div className="search-widget mb-50 d-block d-xl-none">
                                <div className="search-wrap">
                                    <input 
                                        type="search" 
                                        placeholder="Search by name..." 
                                        name="s" 
                                        className="search-input" 
                                        value={searchQuery} // Bind the input value to searchQuery
                                        onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery on change
                                    />
                                    <button type="submit" value="Search">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 pr-35 md-pr-15 md-mb-50">
                            <div className="row">
                                {/* Render filtered news */}
                                <NewsCard news={filteredNews} />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="widget-area">
                                <div className="search-widget mb-50 d-none d-xl-block">
                                    <div className="search-wrap">
                                        <input 
                                            type="search" 
                                            placeholder="Search by name..." 
                                            name="s" 
                                            className="search-input" 
                                            value={searchQuery} // Bind the input value to searchQuery
                                            onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery on change
                                        />
                                        <button type="submit" value="Search">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                                <RecentPost recentNews={News.slice().reverse().slice(0,3)} /> {/* Pass filteredNews to RecentPost */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsList;
